import { render, staticRenderFns } from "./MyDossiersTable.vue?vue&type=template&id=00e626f7&scoped=true"
import script from "./MyDossiersTable.vue?vue&type=script&lang=ts"
export * from "./MyDossiersTable.vue?vue&type=script&lang=ts"
import style0 from "./MyDossiersTable.vue?vue&type=style&index=0&id=00e626f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e626f7",
  null
  
)

export default component.exports